<template>
  <div>
    <div>
      <div class="alert alert-info mt-3">
        <div class="row">
          <div class="col-1 d-flex border-right">
            <icon :icon="['fad', 'info']" class="text-info fa-3x mx-auto my-auto"/>
          </div>
          <div class="col">
            For each Physicians abstract submission a non-refundable fee of € 45 must be paid to be able to submit an
            abstract.<br>
            Click the "Pay abstract fee" button to proccess the credit card payment.<br>
            You will receive an invoice once the payment has beend processed. This can take up to two hours.<br>
            <br>
            We accept the following card: MasterCard and Visa.<br>
            <br>
            For questions regarding the payment please refer to <a
              href="mailto:abstracts@ebmt.org">abstracts@ebmt.org</a>.
          </div>
        </div>
      </div>
      <div>
        <button class="btn btn-success mb-3" @click="startPayment()">
          <icon :icon="['fab', 'cc-stripe']"/>
          Pay abstract fee
        </button>
      </div>
      <div class="row">
        <div class="col d-flex">
          <span class="my-auto">Accepted:&nbsp;</span>
          <icon :icon="['fab', 'cc-mastercard']" class="fa-2x text-success"/>&nbsp;<icon :icon="['fab', 'cc-visa']"
                                                                                         class="fa-2x text-success"/>
        </div>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col d-flex">
        <router-link
            :to="previousSite(getCurrentPages(abstract.setting_submission_id), getCurrentPageByType(abstract.setting_submission_id, 4).id)"
            class="mr-auto">
          <button type="button" class="btn btn-info">
            <icon :icon="['fas', 'angle-left']" size="lg"/>
            {{ wording[0].buttons.back }}
          </button>
        </router-link>
        <router-link
            :to="nextSite(getCurrentPages(abstract.setting_submission_id), getCurrentPageByType(abstract.setting_submission_id, 4).id)"
            class="ml-auto"
            v-if="hasNextSite(getCurrentPages(abstract.setting_submission_id), getCurrentPageByType(abstract.setting_submission_id, 4).id)">
          <button type="button" class="btn btn-info float-right">{{ wording[0].buttons.next }}
            <icon :icon="['fas', 'angle-right']" size="lg"/>
          </button>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import {StripeCheckout} from '@vue-stripe/vue-stripe';
import {mapActions, mapGetters, mapState} from "vuex";

export default {
  components: {},
  data: () => ({
    loading: false,
    routepath: window.location,
  }),
  created() {
    if (this.abstract.paid === true || this.abstract.payment_process === true) {
      this.$router.push('payment/success');
    }
  },
  computed: {
    ...mapState([
      'user', 'wording', 'settings', 'processing', 'abstract'
    ]),
    ...mapGetters([
      'getCurrentPages', 'getCurrentPageById', 'getCurrentPageByType'
    ]),
  },
  methods: {
    ...mapActions('payment', ['START_PAYMENT_CHECKOUT']),
    async startPayment() {
      let control = {'abstract_id': this.$route.params.id, 'success_url': this.routepath + '/success', 'cancel_url': this.routepath + ''}
      await this.START_PAYMENT_CHECKOUT(control).then((result) => {
        window.location = result.data;
      }).catch((error) => {
        alert('The payment process could not be initialized');
      })
    },
  }
}
</script>
